<!--
------------------------------------------------------------------------------
-- 'ShpSnackbar'
------------------------------------------------------------------------------
------------------------------------------------------------------------------
-- Autor                 -- fecha       -- versión  -- cambios
------------------------------------------------------------------------------
-- Ivan Ferrando        18/09/2019        1.1       Creación
------------------------------------------------------------------------------
-- Resumen: modal que te indica un texto durante un tiempo
--
-- Importante: Tener instalado el BUS, mdi-icons
--
-- Propiedades:
--   text -- String -- Requerido -- texto del contenido de la modal
--   value  -- Boolean -- Requerido -- levanta y cierra la modal
--   type -- String -- ['success', 'info', 'error'] sirve para sacar un color u otro según el tipo
--   time -- Number -- tiempo que muestra el snackbar
--   data -- String -- Datos adicionales
------------------------------------------------------------------------------
-->
<template>
  <v-snackbar v-model="showSnackbar" bottom multi-line :right="dScreenWidth > 600" :timeout="timeSnackbar" :color="typeSnackbar + 'Snackbar'">
    <v-row wrap align="center" justify="space-around">
      <v-col cols="auto" class="px-1">
        <v-icon v-if="typeSnackbar === 'success'">mdi-check-circle-outline</v-icon>
        <v-icon v-else-if="typeSnackbar === 'warning'">mdi-information-outline</v-icon>
        <v-icon v-else-if="typeSnackbar === 'error'">mdi-alert-circle-outline</v-icon>
      </v-col>
      <v-col cols="9" class="px-1">{{textSnackbar}}</v-col>
      <v-col v-if="dataSnackbar" cols="auto" class="px-1 ml-auto">
        <v-btn dark icon depressed @click="showDataSnackbar = !showDataSnackbar" class="mx-0">
          <v-icon>
            mdi-information
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="px-1">
        <v-btn icon depressed @click="showSnackbar = false" class="mx-0">
          <v-icon color="datDark">mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col v-if="showDataSnackbar" cols="12" class="snackbarData py-1 px-2">
        <span>{{dataSnackbar}}</span>
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {

  data () {
    return {
      showSnackbar: false,
      showDataSnackbar: false,
      textSnackbar: '',
      typeSnackbar: 'success',
      timeSnackbar: 2000,
      dataSnackbar: '',
      productSanckbar: {},
      dScreenWidth: screen.width
    }
  },
  computed: {
  },
  mounted () {
    this.$bus.$on('showSnackbar', snackbar => {
      this.textSnackbar = snackbar.text ? snackbar.text : ''
      this.dataSnackbar = snackbar.data ? snackbar.data : ''
      this.typeSnackbar = snackbar.type ? snackbar.type : 'success'
      this.timeSnackbar =
        typeof snackbar.time === 'number' ? snackbar.time : 5000
      this.showDataSnackbar = false
      this.showSnackbar = true
      this.productSanckbar = snackbar.productSelected ? snackbar.productSelected : ''
    })
  },
  beforeDestroy () {
    this.$bus.$off('showSnackbar')
  }
}
</script>
